import usePollingLogChunks from '@/hooks/usePollingLogChunks';

const useTaskLog = ({ taskId, appSlug }: { taskId: string | null; appSlug: string }) =>
  usePollingLogChunks({
    url: `/v0.1/apps/${appSlug}/tasks/${taskId}/log`,
    queryKey: ['apps', appSlug, 'tasks', taskId, 'log'],
    enabled: Boolean(taskId),
  });

export default useTaskLog;
